<button class="menu-toggler" aria-label="Åbn udvidet menu" aria-pressed="false" aria-expanded="false">
  <div class="navigation-hamburger">
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
  </div>
</button>
